import { Box } from '@mui/material';
import React from 'react';

interface FootScanImageProps {
    image: {
        key: string;
        src: string;
        alt: string;
    }
    onError?: () => void;
    onLoad?: () => void;
}

const FootScanImage = (props: FootScanImageProps) => {
    const { image, onError, onLoad } = props;

    const handleFootImageError = () => {
        if (onError) {
            onError();
        }
    };

    const isProfileImage = !!image?.alt && image?.alt.toLowerCase().includes('profile');

    if (!image) {
        return null;
    }

    if (isProfileImage) {
        return (
            <Box
                sx={{
                    flex: 1,
                    height: 'inherit',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 3,
                }}
                data-testid="FootScanImage"
            >
                <Box
                    component="img"
                    style={{
                        maxHeight: '100%',
                        maxWidth: '100%',
                        boxSizing: 'border-box',
                        objectFit: 'contain',
                    }}
                    src={image.src}
                    alt={image.alt}
                    onError={handleFootImageError}
                    onLoad={onLoad}
                />
            </Box>
        );
    }
    return (
        <Box
            sx={{
                padding: 0.5,
                flex: 1,
                height: 'inherit',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                objectFit: 'cover',
            }}
            data-testid="FootScanImage"
        >
            <Box
                component="img"
                sx={{
                    maxHeight: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                    objectFit: 'contain',
                }}
                src={image.src}
                alt={image.alt}
                onError={handleFootImageError}
                onLoad={onLoad}
            />
        </Box>
    );
};

export default FootScanImage;

FootScanImage.defaultProps = {
    onError: undefined,
    onLoad: undefined,
};
